export class UdfCategory {
  displayName: string;
  displayOrder: number;
  id: number;
}
